import AWSAppSyncClient, { createAppSyncLink } from 'aws-appsync';
import Amplify from 'aws-amplify';
// installed with appsync
import { ApolloLink } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { createHttpLink } from 'apollo-link-http';

const APP_SYNC_CONFIG = {
  url: process.env.REACT_APP_STAGE === 'dev' ? 'https://zclcahed65epfdf3g4pjtkpnri.appsync-api.us-west-2.amazonaws.com/graphql' : 'https://rtkq5ona7vbdtffdyegbr7daxi.appsync-api.us-west-2.amazonaws.com/graphql',
  region: 'us-west-2',
  auth: {
    type: 'AMAZON_COGNITO_USER_POOLS',
    jwtToken: async () => {
      try {
        const session = await Amplify.Auth.currentSession();
        return session.idToken.jwtToken;
      } catch (error) {
        console.log(error);
        return '';
      }
    }
  }
};

// add a custom header that indicates this is a legacy employee making the request
export default new AWSAppSyncClient(APP_SYNC_CONFIG, {
  link: createAppSyncLink({
    ...APP_SYNC_CONFIG,
    resultsFetcherLink: ApolloLink.from([
      setContext((request, previousContext) => ({
        headers: {
          ...previousContext.headers,
          'legacy-user-type': 'employee'
        }
      })),
      createHttpLink({
        uri: APP_SYNC_CONFIG.url
      })
    ])
  })
});
